// extracted by mini-css-extract-plugin
export default {"container":"BioSection_container__XfhKI","sectionTitle":"BioSection_sectionTitle__IQmRN","card":"BioSection_card__3+WJU","bioText":"BioSection_bioText__zINK3"};